import { Observable } from 'rxjs';
import { ApiRequestOptions } from '../../../core/services/api/request-options';
import { AccountObjectApiFacade } from '../account-object/account-object.api-facade';
import { CategoryGroup } from './category-group.model';

export class CategoryGroupApiFacade extends AccountObjectApiFacade<CategoryGroup> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<CategoryGroup> {
        return this.GET(`/accounts/${accountId}/categorygroups/${id}`, options)
            .map(object => new CategoryGroup(object));
    }

    getAll(accountId: string): Observable<Array<CategoryGroup>> {
        return this.CGET(`/accounts/${accountId}/categorygroups`)
            .map(objects => objects.map(object => new CategoryGroup(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category-group/category-group.api-facade.ts